import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Projects from './components/Projects';
import ContactMe from './components/ContactMe';
import MyAccounts from './components/Projects/MyAccounts';
import HMBR from './components/Projects/HMBR';
import NBCMotors from './components/Projects/NBCMotors';
import AboutMe from './components/AboutMe';
import Blogs from './components/Blogs';
import Skills from './components/Skills';

function App() {
  return (
    <div className="App">
      <Navbar></Navbar>
      <Routes>
        <Route path="/" element={<Dashboard/>}>
          <Route index element={<Home/>}></Route>
          <Route path="projects" element={<Projects/>}></Route>
          <Route path="contact" element={<ContactMe/>}></Route>
          <Route path="about" element={<AboutMe/>}></Route>
          <Route path="blogs" element={<Blogs/>}></Route>
          <Route path="skills" element={<Skills/>}></Route>
          <Route path='projects/my-accounts' element={<MyAccounts/>}></Route>
          <Route path='projects/hmbr-international' element={<HMBR/>}></Route>
          <Route path='projects/nbc-motors' element={<NBCMotors/>}></Route>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
